import { render, staticRenderFns } from "./CreateWeightRuleContent.vue?vue&type=template&id=16c2cf0d&scoped=true&"
import script from "./CreateWeightRuleContent.vue?vue&type=script&lang=js&"
export * from "./CreateWeightRuleContent.vue?vue&type=script&lang=js&"
import style0 from "./CreateWeightRuleContent.vue?vue&type=style&index=0&id=16c2cf0d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c2cf0d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16c2cf0d')) {
      api.createRecord('16c2cf0d', component.options)
    } else {
      api.reload('16c2cf0d', component.options)
    }
    module.hot.accept("./CreateWeightRuleContent.vue?vue&type=template&id=16c2cf0d&scoped=true&", function () {
      api.rerender('16c2cf0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Rates/ModalComponents/CreateWeightRuleContent.vue"
export default component.exports